import React from "react";
import EqualWidthList from "../../../../../common/components/equal-width-list/EqualWidthList";
import { Box, Button } from "@mui/material";
import "../tenant-basic-details/tenant-basic-details.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../../constants/routes";
import { formatTitleCase } from "../../../../../utils/utils";
import { useResourcePermissions } from "../../../../../common/hooks/resource-permissions";
import MODULES from "../../../../../constants/modules";

interface TenantUserDetailsProps {
  tenantData: any;
  path?: any;
}

const TenantPlanDetails: React.FC<TenantUserDetailsProps> = ({
  tenantData,
  path = routes.PARTNER_DETAILS_CHANGE_PLAN,
}) => {
  const navigate = useNavigate();
  const { purchased_subscription_plan } = tenantData || {};
  const handleUnlimited = (value: any) => {
    return value == -1 ? "Unlimited" : value;
  };
  const { canWrite } = useResourcePermissions(MODULES.PARTNER_LIST);

  const handleLeadsContacts = (leadsValue: any, contactsValue: any) => {
    const leads = handleUnlimited(leadsValue);
    const contacts = handleUnlimited(contactsValue);
    if (leads === contacts) {
      return leads;
    }
    return `${leads} & ${contacts}`;
  };
  return (
    <Box className="tenant-basic-details-wrapper">
      <Box className="tenant-basic-details-header">
        {canWrite && (
          <Button
            variant="outlined"
            className="tenant-basic-details-header-button"
            onClick={() => {
              navigate(path, {
                state: {
                  activePlanDetails: purchased_subscription_plan,
                  tenantData: tenantData,
                },
              });
            }}
          >
            {purchased_subscription_plan?.plan_name
              ? "Change Plan"
              : "Choose Plan"}
          </Button>
        )}
      </Box>
      <Box className="tenant-basic-details-content" gap={5}>
        <Box className="tenant-basic-details-content-header">
          <EqualWidthList
            labelValue={
              purchased_subscription_plan?.plan_name ||
              purchased_subscription_plan?.planName
            }
            label="Plan"
            className="plan-button-wrapperr"
            enableTooltip
          />
          <EqualWidthList
            labelValue={handleUnlimited(
              purchased_subscription_plan?.no_of_users
            )}
            label="User Limit"
          />
          <EqualWidthList
            labelValue={purchased_subscription_plan?.storage_limits}
            label="Data Storage Limit"
          />
          <EqualWidthList
            labelValue={handleUnlimited(
              handleUnlimited(
                purchased_subscription_plan?.automation_rules_limit
              )
            )}
            label="Automation Rules"
          />
        </Box>
        <Box className="tenant-basic-details-content-header">
          <EqualWidthList
            label="Leads and Contact"
            labelValue={handleLeadsContacts(
              purchased_subscription_plan?.no_of_leads,
              purchased_subscription_plan?.no_of_contacts
            )}
          />{" "}
          <EqualWidthList
            labelValue={handleUnlimited(
              purchased_subscription_plan?.api_calls_per_month
            )}
            label="API Calls"
          />
          <EqualWidthList
            labelValue={formatTitleCase(
              purchased_subscription_plan?.support_level
            )}
            label="Support"
          />
          <EqualWidthList
            labelValue={
              purchased_subscription_plan?.hasOwnProperty("reporting_level")
                ? purchased_subscription_plan.reporting_level
                  ? "Yes"
                  : "No"
                : "-"
            }
            label="Reports"
          />{" "}
        </Box>
      </Box>
    </Box>
  );
};

export default TenantPlanDetails;
